module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "base-input"
  }, [_c('div', {
    staticClass: "base-input-label"
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "base-input-box"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "base-input-messages"
  }, [_vm._v("\n        " + _vm._s(_vm.hint) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-066e5573"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/inputs/BaseInput.vue
// module id = 2434
// module chunks = 1